export default {"src":"/_next/static/image/src/images/about-parent.f6a6536eb8efd0aa5d8316af537aa0c6.svg","height":40,"width":48};